interface DataAnalyticsIconProps {
    width?: string | number;
    height?: string | number;
    className?: string;
    fillColor?: string;
  }
  
  const DataAnalyticsIcon: React.FC<DataAnalyticsIconProps> = ({
    width = 32,
    height = 32,
    className,
    fillColor = "#0557D5"
  }) => {
    return (
      <svg 
        width={width} 
        height={height} 
        viewBox="0 0 32 32" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-label="Data Analytics Icon"
      >
        <rect width="32" height="32" rx="4" fill={fillColor} />
        <g clipPath="url(#clip0_494_5711)">
          <path 
            d="M19.9922 21.3762H8.37536C7.93093 21.3762 7.56738 21.7414 7.56738 22.1878C7.56738 22.6343 7.93093 23 8.37536 23H19.9922C20.4365 23 20.8003 22.6343 20.8003 22.1878C20.8003 21.7414 20.4365 21.3762 19.9922 21.3762Z" 
            fill="white"
          />
          <path 
            d="M22.7806 23C22.3362 23 21.9727 22.6343 21.9727 22.1878C21.9727 21.7414 22.3362 21.3762 22.7806 21.3762H26.1519C26.5964 21.3762 26.9599 21.7414 26.9599 22.1878C26.9599 22.6343 26.5964 23 26.1519 23H22.7806Z" 
            fill="white"
          />
          <path 
            d="M24.3587 19.9058C23.9142 19.9058 23.5505 19.5407 23.5505 19.0942C23.5505 18.6477 23.9142 18.2825 24.3587 18.2825H26.1519C26.5963 18.2825 26.9599 18.6477 26.9599 19.0942C26.9599 19.5407 26.5963 19.9058 26.1519 19.9058H24.3587Z" 
            fill="white"
          />
          <path 
            d="M24.8116 16.8118C24.3672 16.8118 24.0037 16.4466 24.0037 15.9996C24.0037 15.5531 24.3672 15.1881 24.8116 15.1881H26.152C26.5965 15.1881 26.96 15.5531 26.96 15.9996C26.96 16.4466 26.5965 16.8118 26.152 16.8118H24.8116Z" 
            fill="white"
          />
          <path 
            d="M24.3859 13.7175C23.9414 13.7175 23.5779 13.3523 23.5779 12.9059C23.5779 12.4594 23.9414 12.094 24.3859 12.094H26.152C26.5964 12.094 26.9599 12.4594 26.9599 12.9059C26.9599 13.3523 26.5964 13.7175 26.152 13.7175H24.3859Z" 
            fill="white"
          />
          <path 
            d="M22.8512 10.6238C22.4068 10.6238 22.043 10.2583 22.043 9.81184C22.043 9.36535 22.4068 8.99998 22.8512 8.99998H26.1518C26.5963 8.99998 26.9598 9.36535 26.9598 9.81184C26.9598 10.2583 26.5963 10.6238 26.1518 10.6238H22.8512Z" 
            fill="white"
          />
          <path 
            d="M21.5702 18.2822H6.10137C5.65693 18.2822 5.29321 18.6477 5.29321 19.0942C5.29321 19.5407 5.65693 19.9058 6.10137 19.9058H21.5702C22.0147 19.9058 22.3785 19.5407 22.3785 19.0942C22.3785 18.6477 22.0147 18.2822 21.5702 18.2822Z" 
            fill="white"
          />
          <path 
            d="M22.023 15.1881H3.80798C3.36353 15.1881 3 15.5531 3 15.9996C3 16.4464 3.36353 16.8118 3.80798 16.8118H22.023C22.4674 16.8118 22.8311 16.4464 22.8311 15.9996C22.8311 15.5531 22.4674 15.1881 22.023 15.1881Z" 
            fill="white"
          />
          <path 
            d="M21.5972 12.094H4.95446C4.51001 12.094 4.14648 12.4594 4.14648 12.9059C4.14648 13.3523 4.51001 13.7175 4.95446 13.7175H21.5972C22.0418 13.7175 22.4053 13.3523 22.4053 12.9059C22.4053 12.4594 22.0418 12.094 21.5972 12.094Z" 
            fill="white"
          />
          <path 
            d="M20.0627 8.99998H10.8062C10.3618 8.99998 9.99805 9.36535 9.99805 9.81184C9.99805 10.2583 10.3618 10.6238 10.8062 10.6238H20.0627C20.5071 10.6238 20.8706 10.2583 20.8706 9.81184C20.8706 9.36535 20.5071 8.99998 20.0627 8.99998Z" 
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_494_5711">
            <rect width="24" height="14" fill="white" transform="translate(3 9)" />
          </clipPath>
        </defs>
      </svg>
    );
  };
  
  export default DataAnalyticsIcon;